<div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
  <div class="btn-group btn-icon-group" role="group" aria-label="First group">
    <ng-content></ng-content>
    <ng-container *ngFor="let button of buttons">
      <ng-container *ngPermissions="button.permissions ? button.permissions : null">
        <ng-template [ngIf]="button.link" [ngIfElse]="actionButton">
          <a [sbRouterLink]="button.link" [pathParams]="button.pathParams ? button.pathParams : null"
             [queryParams]="button.queryParams ? button.queryParams : null"
             [ngbTooltip]="button.translate ? (button.tooltip | translate) : button.tooltip"
             container="body" placement="top" class="btn" [ngClass]="button.btnClass">
            <button type="button" class="btn" [ngClass]="button.btnClass">
              <sb-icon [icon]="button.icon"></sb-icon>
            </button>
          </a>
        </ng-template>
        <ng-template #actionButton>
          <button (click)="clickedAction.emit(button)" [ngbTooltip]="button.translate ? (button.tooltip | translate) : button.tooltip"
                  placement="top" container="body" type="button"
                  class="btn" [ngClass]="button.btnClass">
            <sb-icon [icon]="button.icon"></sb-icon>
          </button>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>
